export default "__VITE_ASSET__Bvisq6y___"